// run passed functions one by one and emit the last function's return value
export const run =
  <T>(...fns: Array<((arg: T) => any) | undefined>) =>
  (value: T) => {
    const filteredFns = fns.filter(Boolean) as Array<(arg: T) => any>;
    const returnValue = filteredFns.reduce((acc: any, fn) => {
      acc = fn(value);
      return acc;
    }, undefined);
    return returnValue;
  };
